import { useEffect, useState } from 'react';
import { where } from 'firebase/firestore';
import { queryDocuments } from '../../../utility/firebaseHelpers';

/**
 * Checks user's identity verification status
 * Used to conditionally show IdentityVerificationForm
 */
export const useVerificationCheck = (currentUser: any) => {
  const [isVerified, setIsVerified] = useState<boolean>(false);

  useEffect(() => {
    const checkVerificationStatus = async () => {
      if (!currentUser) return;
      try {
        const verifications = await queryDocuments('identityVerification', [
          where('userId', '==', currentUser.uid),
          where('status', '==', 'approved'),
        ]);
        setIsVerified(verifications.length > 0);
      } catch (err) {
        console.error('Error checking verification status:', err);
      }
    };

    checkVerificationStatus();
  }, [currentUser]);

  return { isVerified };
};

export default useVerificationCheck;
